// extracted by mini-css-extract-plugin
export default {"bar":"style_bar__Xw2Dv","fontSize":"style_fontSize__mUOvM","progressVal":"style_progressVal__m8WAy"};